import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FlexBox } from '../common/Reusables';
import SnackBar from '../common/SnackBar/SnackBar';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import ForumIcon from '@material-ui/icons/Forum';
import { Box } from '@material-ui/core';
import { useQuery } from 'react-query';
import { getBilling } from '../api/billing';
const Support = () => {
  const { data } = useQuery(['current-billing'], getBilling);
  const [copy, setCopy] = useState(false);

  useEffect(() => {
    if (!copy) return;

    setTimeout(() => {
      setCopy(false);
    }, 1500);
  }, [copy]);
  return (
    <Support.Wrapper>
      <h1>We are here for you </h1>
      <div className='sub-text'>
        Support hours are Monday - Friday, 9am to 5pm
      </div>

      <div className='cards'>
        {!data?.plan_code?.includes('free') && (
          <div className='card'>
            <FlexBox>
              <Box display='flex' alignItems='center' className='left'>
                <ForumIcon htmlColor='#878787' />
                <div>
                  <div className='top'>Live Chat</div>
                  <div className='bottom'>
                    Chat with our experts by clicking chat icon at bottom right
                    corner
                  </div>
                </div>
              </Box>
              {/* <Button>Start chat</Button> */}
            </FlexBox>
          </div>
        )}
        <div className='card'>
          <FlexBox>
            <Box display='flex' alignItems='center' className='left'>
              <EmailIcon htmlColor='#878787' />
              <div>
                {' '}
                <div className='top'>Email us</div>
                <div className='bottom'>support@bizedgeapp.com</div>
              </div>
            </Box>
            <Button
              onClick={() => {
                navigator.clipboard.writeText('support@bizedgeapp.com');
                setCopy(true);
              }}
            >
              Copy
            </Button>
          </FlexBox>
        </div>
        {!data?.plan_code?.includes('free') && (
          <div className='card'>
            <FlexBox>
              <Box display='flex' alignItems='center' className='left'>
                <PhoneIcon htmlColor='#878787' />
                <div>
                  <div className='top'>Phone Support</div>
                  <div className='bottom'>070-812-04394</div>
                </div>
              </Box>
              <Button
                onClick={() => {
                  navigator.clipboard.writeText('+2347081204394');
                  setCopy(true);
                }}
              >
                Copy
              </Button>
            </FlexBox>
          </div>
        )}
      </div>
      {copy && <SnackBar severity='success'>Copied to Clipboard</SnackBar>}
    </Support.Wrapper>
  );
};

export default Support;

Support.Wrapper = styled.div`
  margin-top: 20px;
  h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 128.86%;
    color: #545454;
    margin-bottom: 0;
    color: #171717;
  }
  .sub-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 128.86%;
    margin-top: 10px;
  }
  .texts {
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    color: #545454;
  }
  .cards {
    margin-top: 21px;
  }
  .card {
    background: #ffffff;
    border: 0.854961px solid #e1e1e1;
    box-shadow: 0px 5px 18px rgba(40, 41, 61, 0.07);
    border-radius: 10px;
    height: 75px;
    padding: 0 13px 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 10px 0;
    .left {
      svg {
        margin-right: 10px;
      }
    }
    .top {
      font-weight: 600;
      font-size: 12px;
      line-height: 13px;
      color: #878787;
      margin-bottom: 6px;
    }
    .bottom {
      font-weight: 400;
      font-size: 14px;
      line-height: 128.86%;
      color: #171717;
    }
  }
`;

const Button = styled.button`
  font-weight: 600;
  font-size: 10px;
  line-height: 128.86%;
  color: #2898a4;
  padding: 6px 16px;
  background: #eaf8fa;
  border-radius: 165px;
  height: 25px;
  border: none;
  cursor: pointer;
`;
